const apiUrl = process.env.REACT_APP_API_URL;

function getBasicAuthHeader() {
  const username = process.env.REACT_APP_API_USERNAME;
  const password = process.env.REACT_APP_API_PASSWORD;
  const encodedCredentials = btoa(`${username}:${password}`);
  return `Basic ${encodedCredentials}`;
}

function authHeaders() {
  return {
    'Content-Type': 'application/json',
    Accept: '*/*',
    Authorization: getBasicAuthHeader(),
  };
}

/** Instructor portal tiers — instructor_plan_pricing + instructor_plan_entitlement. */
export async function fetchInstructorPlanPackages() {
  const response = await fetch(`${apiUrl}/api/instructor/plans/pricing`, {
    method: 'GET',
    headers: authHeaders(),
  });
  if (!response.ok) {
    throw new Error(`Instructor plan pricing request failed: ${response.status}`);
  }
  const rows = await response.json();
  return Array.isArray(rows) ? rows : [];
}

/** Learner app tiers — learner_plan_pricing + learner_plan_entitlement. */
export async function fetchLearnerPlanPackages() {
  const response = await fetch(`${apiUrl}/api/learner/plans/pricing`, {
    method: 'GET',
    headers: authHeaders(),
  });
  if (!response.ok) {
    throw new Error(`Learner plan pricing request failed: ${response.status}`);
  }
  const rows = await response.json();
  return Array.isArray(rows) ? rows : [];
}

/** Persists instructor tier pricing and entitlement meters. */
export async function saveInstructorPlanPackage(tier, payload) {
  const response = await fetch(`${apiUrl}/api/instructor/plans/${encodeURIComponent(tier)}`, {
    method: 'PUT',
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    throw new Error(`Save instructor plan failed: ${response.status}`);
  }
  return response.json();
}

/** Persists learner tier pricing and entitlement meters. */
export async function saveLearnerPlanPackage(tier, payload) {
  const response = await fetch(`${apiUrl}/api/learner/plans/${encodeURIComponent(tier)}`, {
    method: 'PUT',
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    throw new Error(`Save learner plan failed: ${response.status}`);
  }
  return response.json();
}
